import { Box, Typography } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { Dispatch, SetStateAction } from 'react'

import { patientCareTeamObj } from '../../providers/CareTeam/types'
import { themeColors } from '../../theme'
import { Modal } from '../Modal/Modal'

interface CareTeamModalProps {
  setShowCareTeamModal: Dispatch<SetStateAction<boolean>>
  showCareTeamModal: boolean
  patientCareTeam: patientCareTeamObj[]
}

export const CareTeamModal = ({
  showCareTeamModal,
  setShowCareTeamModal,
  patientCareTeam,
}: CareTeamModalProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Modal
        open={showCareTeamModal}
        setOpen={setShowCareTeamModal}
        title={'Patient Care Team'}
        width={'28%'}
        ModalContent={
          <Box sx={{ width: '92%', margin: 'auto' }}>
            {patientCareTeam &&
              patientCareTeam.map((provider, index) => {
                return (
                  <Box
                    sx={{
                      display: 'flex',
                      margin: '7px',
                      alignItems: 'center',
                    }}
                    key={`provider-${provider.providerId}-index`}
                  >
                    <Typography
                      sx={{
                        fontSize: '14px',
                        lineHeight: '17px',
                        color: themeColors.gray20,
                        margin: '10px',
                      }}
                    >
                      {provider.isOnline ? '🟢' : '⚫️'}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: '18px',
                        lineHeight: '17px',
                        color: themeColors.gray20,
                      }}
                    >
                      {provider.name}
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: '17px',
                        lineHeight: '17px',
                        color: themeColors.gray20,
                        margin: '10px',
                      }}
                    >
                      <em>{provider.roles[0]}</em>
                    </Typography>
                  </Box>
                )
              })}
          </Box>
        }
      />
    </LocalizationProvider>
  )
}
